import {Injectable} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";

@Injectable()
export class DataSharingService {

  dealUnitOutData: any = [];
  dealUnitInData: any = [];
  commitmentOutData: any = [];
  commitmentInData: any = [];
  requestDataSubject = new Subject<any>();
  requestDataJson: any;
  dealId: string;
  homeTadIg: string;
  visitingTadIg: string;
  tableDataSubject = new BehaviorSubject<any>({});
  data = this.tableDataSubject.asObservable();
  selectedDealId = '';
  getTableDataFlag: boolean;
  vpmnNetworkCenterCountry: string;
  vpmnNetworkCenterOperator: string;
  vpmnNetworkCenterTadig: string;
  marketSimulatorLiveDataSubject = new BehaviorSubject<any>({});
  marketSimulatorLiveData = this.marketSimulatorLiveDataSubject.asObservable();
  callActivitySelected = [];
  callActivityDataSubject = new BehaviorSubject<any>([]);
  productDBSearchFormValue: any;

  constructor() {
  }
  setDealUnitData(data , dealUnit) {
    if (dealUnit.toLowerCase() === 'out') {
      this.dealUnitOutData.push(data);
    } else if (dealUnit.toLowerCase() === 'in') {
      this.dealUnitInData.push(data);
    }
  }

  setCommitmentData(data , dealUnit) {
    if (dealUnit.toLowerCase() === 'out') {
      this.commitmentOutData.push(data);
    } else if (dealUnit.toLowerCase() === 'in') {
      this.commitmentInData.push(data);
    }
  }

  getOutDealUnitData() {
     return this.dealUnitOutData;
  }

  getInDealUnitData() {
    return this.dealUnitInData;
  }

  getOutCommitmentData() {
    return this.commitmentOutData;
  }

  getInCommitmentData() {
    return this.commitmentInData;
  }

  updatedTableDataSelection(data: any) {
    this.tableDataSubject.next(data);
    this.getTableDataFlag = true;
  }

  updateMarketSimulatorLiveData(data: any) {
    this.marketSimulatorLiveDataSubject.next(data);
  }

  updateCallActivityData(data: any) {
    this.callActivityDataSubject.next(data);
  }


}
